import React, { useState } from 'react';
import { useThree, useFrame } from '@react-three/fiber';
import { useScroll, Box } from '@react-three/drei';
// Models
import { Logo } from './models/JSLogo';
import { Figma } from './models/FigmaModel2';
import { HTML5 } from './models/HTML5Model';
import { CSS3 } from './models/CSS3Model';
import { JavaScript } from './models/JavaScriptModel';
import { ReactLogo } from './models/ReactModel';
import { ThreeJS } from './models/ThreeJSModel';
import { Postgres } from './models/PostgresModel';
import { Linux } from './models/LinuxModel';
import { AWS } from './models/AWSModel';
import { API } from './models/APIModel';
import { Git } from './models/GitModel';
import { NodeJS } from './models/NodeJSModel';
import { Python } from './models/PythonModel';
import { CPP } from './models/CPPModel';
import { Java } from './models/JavaModel';
import { MeshPhysicalMaterial } from 'three';

const models = {
    JSLogo: Logo,
    Figma: Figma,
    HTML5: HTML5,
    CSS3: CSS3,
    JavaScript: JavaScript,
    ReactLogo: ReactLogo,
    ThreeJS: ThreeJS,
    Postgres: Postgres,
    Linux: Linux,
    AWS: AWS,
    API: API,
    Git: Git,
    NodeJS: NodeJS,
    Python: Python,
    CPP: CPP,
    Java: Java
};

function LazyModel({ model: ModelComponent, position, scale, name }) {
    const { height } = useThree((state) => state.viewport)
    const [inView, setInView] = useState(false);
    const [, yPos] = position;
    const normalisedPos = Math.abs(yPos / (height * 3));
    const data = useScroll();

    useFrame(() => {
        if (!inView && data.scroll.current >= normalisedPos - 0.1){
            setInView(true);
        }
        // Returning a cleanup function to unsubscribe from frame updates
        return () => {};
    });

    return(
        <>
            {
                inView 
                &&
                <ModelComponent position={position} scale={scale} showBox={false} />
            }
        </>
    )  
}

function Model(props){
    // Get the correct model
    const ModelComponent = models[props.model];

    // Create a new instance of MeshPhysicalMaterial using the new keyword
    const errorMaterial = new MeshPhysicalMaterial({ color: 'blue', metalness: 0, roughness: 0.5 });

    if (!ModelComponent) {
        // If the specified model is not found, render a placeholder or handle the error accordingly
        return (
            <Box 
                args={[0.5, 0.5, 0.5]}
                material={errorMaterial}
                castShadow
                receiveShadow
                position={props.position}
            />
        );
      }

    return props.lazy ? 
    <LazyModel model={ModelComponent} position={props.position} scale={props.scale} name={props.model} /> :
    <ModelComponent position={props.position} scale={props.scale} />;
}

export {LazyModel, Model}